import builder from '../builder';
import View from '../../streamline-icons/light/view-1.svg';

export default builder('IconViewLight', View);
